import React, { useState } from 'react';
import {
  Button,
  useTheme
} from '@mui/material';

import { CustomIcon } from 'modules/components/layer00';
import {
  SavePlanModal,
  SavePlanSetModal
} from 'modules/components/layer17';
import { ActivityHeaderSectionWithSearchLayout } from 'modules/components/layer32';
import { useAccessState } from 'modules/common';

export type PlanSetsHeaderSectionProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: PlanSetsHeaderSectionProps) => {

  return (
    <ActivityHeaderSectionWithSearchLayout.FC
      title='Plan Sets'
      subtitle='List of plan sets for the project'
      searchBar={<></>}
      actionButtons={(

        <ActionButtonsGroup />
      )}
    />

  );
};

type ActionButtonsGroupProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
const ActionButtonsGroup = (props: ActionButtonsGroupProps) => {
  const theme = useTheme();
  const [
    isVisible,
    setIsVisible
  ] = useState(false);
  const [
    isSavePlanSetVisible,
    setIsSavePlanSetVisible
  ] = useState(false);
  const access = useAccessState('Plan');

  return (
    <>
      {isVisible && (
        <SavePlanModal.FC
          id=''
          isVisible={isVisible}
          handleClose={() => setIsVisible(() => false)}
        />
      )}
      {isSavePlanSetVisible && (
        <SavePlanSetModal.FC
          id=''
          isVisible={isSavePlanSetVisible}
          handleClose={() => setIsSavePlanSetVisible(() => false)}
        />
      )}
      <Button
        variant='outlined'
        disabled={!access.create}
        color='primary'
        onClick={() => setIsSavePlanSetVisible(() => true)}
        startIcon={(
          <CustomIcon.large.FC
            icon='SUITCASE'
            stroke={theme.palette.primary.main}
          />
        )}
      >
        Create new Plan Set
      </Button>
      <Button
        variant='contained'
        color='primary'
        disabled={!access.create}
        onClick={() => setIsVisible(() => true)}
        startIcon={(
          <CustomIcon.large.FC
            icon='PLUS'
            stroke={theme.palette.primary.contrastText}
          />
        )}
      >
        Add Plan
      </Button>

    </>
  );
};
